import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/user/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["customer"],
  endpoints: (builder) => ({
    getCustomers: builder.query({
      query: (getState) => {
        return {
          url: `userList`,
          params: {
            user_type: 0
          }
        }
      },
      providesTags: ["customer"],

    }),
    createOrUpdateCustomer: builder.mutation({
      query: (formData) => {

        return {
          url: `userList`,
          method: 'POST'
        }
      },
      invalidatesTags: ["customer"],
    })
  }),
})

export const { useGetCustomersQuery, useCreateOrUpdateCustomerMutation } = customerApi